module.exports = __webpack_public_path__ + "img/FA1.a508bcb4.png";